import { render, staticRenderFns } from "./RunningWorkflowDetail.vue?vue&type=template&id=2ab1a3fa&scoped=true"
import script from "./RunningWorkflowDetail.vue?vue&type=script&lang=js"
export * from "./RunningWorkflowDetail.vue?vue&type=script&lang=js"
import style0 from "./RunningWorkflowDetail.vue?vue&type=style&index=0&id=2ab1a3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1a3fa",
  null
  
)

export default component.exports